import React from 'react';
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts';

interface CompanyTimeData {
    range: string;
    count: number;
    percentage: number;
}

const companyTimeData: CompanyTimeData[] = [
    { range: '< 1 ano', count: 67, percentage: 31.5 },
    { range: '1-2 anos', count: 45, percentage: 21.1 },
    { range: '3-5 anos', count: 52, percentage: 24.4 },
    { range: '6-10 anos', count: 32, percentage: 15.0 },
    { range: '> 10 anos', count: 17, percentage: 8.0 },
];

const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
            <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
                <p className="font-medium text-gray-900">{data.range}</p>
                <p className="text-sm text-gray-600">
                    {data.count} colaboradores ({data.percentage}%)
                </p>
            </div>
        );
    }
    return null;
};

export default function CompanyTimeRanges() {
    const totalCollaborators = companyTimeData.reduce((sum, item) => sum + item.count, 0);

    return (
        <div className="bg-white rounded-lg shadow p-4">
            {/* Header */}
            <div className="mb-4">
                <h3 className="text-base font-semibold text-gray-900 mb-1">
                    Faixa de Tempo de Casa
                </h3>
                <p className="text-xs text-gray-600">
                    Distribuição por tempo de permanência na empresa
                </p>
            </div>

            {/* Chart */}
            <div className="h-48">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={companyTimeData} margin={{ top: 10, right: 10, left: 10, bottom: 20 }}>
                        <XAxis
                            dataKey="range"
                            tick={{ fontSize: 10 }}
                            axisLine={false}
                            tickLine={false}
                            angle={-45}
                            textAnchor="end"
                            height={60}
                        />
                        <YAxis hide />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar
                            dataKey="count"
                            fill="#8B5CF6"
                            radius={[4, 4, 0, 0]}
                            stroke="#ffffff"
                            strokeWidth={1}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>

            {/* Stats Summary */}
            <div className="mt-4 grid grid-cols-2 gap-3 pt-3 border-t border-gray-200">
                <div className="text-center">
                    <div className="text-lg font-bold text-gray-900">
                        {Math.round((companyTimeData[0].count / totalCollaborators) * 100)}%
                    </div>
                    <div className="text-xs text-gray-500">Novatos (&lt; 1 ano)</div>
                </div>
                <div className="text-center">
                    <div className="text-lg font-bold text-gray-900">
                        {Math.round(((companyTimeData[3].count + companyTimeData[4].count) / totalCollaborators) * 100)}%
                    </div>
                    <div className="text-xs text-gray-500">Veteranos (&gt; 6 anos)</div>
                </div>
            </div>
        </div>
    );
} 